import { useState } from 'react';
import cn from 'classnames';
import { Translate } from '~/i18n';
import { useAuth } from '~/auth';
import { formatNumber } from '~/utils/format-price';
import ChargeWalletModal from '~/components/marketplace/wallet/charge-wallet-modal';
import { WalletOutlineIcon } from '~/svgs/marketplace';

type WalletBalanceCardProps = {
   classNames?: string;
   showBalanceOnly?: boolean;
};
const WalletBalanceCard = ({ classNames, showBalanceOnly = false }: WalletBalanceCardProps) => {
   const { user } = useAuth();
   const [openChargeWalletModal, setOpenChargeWalletModal] = useState(false);

   return (
      <>
         {showBalanceOnly ? (
            <div
               className={cn(
                  'w-full lg:w-[380px] flex justify-between items-center bg-[#EBEBEB] px-3 py-2 rounded-lg',
                  classNames && classNames
               )}>
               <span className="flex items-center font-bold text-lg space-x-2 rtl:space-x-reverse">
                  <WalletOutlineIcon />
                  <span>
                     <Translate
                        parseHTML
                        id="common:price_sar"
                        values={{ amount: formatNumber(user?.wallet_balance || 0) }}
                     />
                  </span>
               </span>
               {user?.profile_strength?.verified_business_profile ? (
                  <span
                     className="font-semibold text-primary cursor-pointer"
                     onClick={() => setOpenChargeWalletModal(true)}>
                     <Translate id="wallet:charge wallet" />
                  </span>
               ) : null}
            </div>
         ) : (
            <div
               className={cn(
                  'w-full lg:w-[250px] flex flex-col bg-[#EBEBEB] px-3 py-2 rounded-lg',
                  classNames && classNames
               )}>
               <span className="flex font-bold text-lg space-x-2 rtl:space-x-reverse">
                  <span>
                     <Translate
                        parseHTML
                        id="common:price_sar"
                        values={{ amount: formatNumber(user?.wallet_balance || 0) }}
                     />
                  </span>
               </span>
               <span className="text-xs font-semibold mb-4">
                  <Translate id="wallet:available spending limit" />
               </span>
               {user?.status === 'Active' && user?.profile_strength?.verified_business_profile ? (
                  <span
                     className="font-semibold text-primary cursor-pointer underline"
                     onClick={() => setOpenChargeWalletModal(true)}>
                     <Translate id="wallet:charge wallet" />
                  </span>
               ) : null}
            </div>
         )}
         <ChargeWalletModal open={openChargeWalletModal} setOpen={setOpenChargeWalletModal} />
      </>
   );
};

export default WalletBalanceCard;
